import React, {
  Suspense,
  Fragment,
  lazy
} from 'react';
import {
  Routes,
  Navigate,
  Route
} from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout'
import AuthGuard from 'src/components/AuthGuard'
import HomeView from 'src/views/home/HomeView';
import GuestGuard from 'src/components/GuestGuard'

import MainLayout from 'src/layouts/MainLayout'
import LoadingScreen from 'src/components/LoadingScreen'


export const renderRoutes = (routes = []) => (
  <Suspense fallback={<LoadingScreen />}>
    <Routes>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Element = route.element;
        console.log(Element);
        return (
          <Route
            key={i}
            path={route.path}
            element={
              <Guard>
                <Layout>
                  {route.routes
                    ? renderRoutes(route.routes)
                    : <Element />}
                </Layout>
              </Guard>
            }
          />
        );
      })}
    </Routes>
  </Suspense>
);

const routes = [
  // {
  //   exact: true,
  //   path: '/',
  //   //element: LanguageView
  //   //element: lazy(() => import('src/views/auth/LoginView'))
  //   //element: () => <Navigate to="/app/reports/dashboard" />
  //   element: () => <Navigate to="/app/management/map" />
  // },
  {
    exact: true,
    path: '/404',
    element: lazy(() => import('src/views/errors/NotFoundView'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/login',
    element: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    path: '/login-unprotected',
    element: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/register',
    element: lazy(() => import('src/views/auth/RegisterView'))
  },
  {
    exact: true,
    path: '/register-unprotected',
    element: lazy(() => import('src/views/auth/RegisterView'))
  },
  {
    path: '/app',
    guard: AuthGuard,
    layout: DashboardLayout,
    routes: [
  /*    {
        exact: true,
        path: '/app/management/players',
        element: lazy(() => import('src/views/players/PlayersListView'))
      },
      {
        exact: true,
        path: '/app/management/players/create',
        element: lazy(() => import('src/views/players/PlayersModify'))
      },
      {
        exact: true,
        path: '/app/management/players/:playerID',
        element: lazy(() => import('src/views/players/PlayersModify'))
      },
  */
      {
        path: '/app/management/applications',
        element: lazy(() => import('src/views/applications/ApplicationsListView'))
      },
      {
        path: '/app/management/applications/create',
        element: lazy(() => import('src/views/applications/ApplicationsModify'))
      },
      {
        path: '/app/management/applications/:applicationID',
        element: lazy(() => import('src/views/applications/ApplicationsModify'))
      },
      {
        path: '/app/management/leaderboards',
        element: lazy(() => import('src/views/leaderboards/LeaderboardsListView'))
      },
      {
        path: '/app/management/leaderboards/create',
        element: lazy(() => import('src/views/leaderboards/LeaderboardsModify'))
      },
      {
        path: '/app/management/leaderboards/:leaderboardID/application/:applicationID',
        element: lazy(() => import('src/views/leaderboards/LeaderboardsModify'))
      },
      {
        path: '/app/account',
        element: () => <Navigate to="/app/account/general" />
      },
      {
        path: '/app/saves',
        element: lazy(() => import('src/views/saves'))
      },
      {
        path: '/app/configs',
        element: lazy(() => import('src/views/configs'))
      },
      {
        path: '/app/nfts',
        element: lazy(() => import('src/views/nfts'))
      },
      {
        path: '/app/subscription',
        element: lazy(() => import('src/views/subscription'))
      },
      {
        path: '/app/reports/dashboard',
        element: lazy(() => import('src/views/reports/DashboardAlternativeView'))
      },
      {
        path: '/app/dashboard',
        element: () => <Navigate to="/app/reports/dashboard" />
      },
      {
        element: () => <Navigate to="/404" />
      }
    ]
  },
  {
    path: '*',
    layout: MainLayout,
    routes: [
      {
        path: '/',
        element: HomeView
      },
      {
        element: () => <Navigate to="/404" />
      }
    ]
  }
];

export default routes;
